import React, { useState, useEffect } from 'react';
import { Typography } from '@mui/material';
import { FaFacebookF } from "react-icons/fa";
import { BsTwitterX } from "react-icons/bs";
import { FaLinkedinIn } from "react-icons/fa";
import { MdOutlineLink } from "react-icons/md";
import { useRouter } from 'next/router';
import { ShowNotification } from '../../utils/notification/snackbarUtils';
import { MdOutlineMailOutline } from "react-icons/md";

export default function SocialLinks(props) {

  const router = useRouter();
  const link = `https://www.kingdomadvisors.com${router.asPath}`;
  const facebook = `https://www.facebook.com/sharer.php?u=${link}`;
  const twitter = `https://twitter.com/intent/tweet?url=${link}`;
  const linkedIn = `https://www.linkedin.com/shareArticle?url=${link}`;

  // Prepare dynamic email link with article information if available
  const articleTitle = props?.content?.title || '';
  // Remove HTML tags from excerpt if present
  const rawExcerpt = props?.content?.excerpt || '';
  const excerptText = rawExcerpt.replace(/<[^>]+>/g, '');

  const subject = encodeURIComponent(`${articleTitle}`);
  const body = encodeURIComponent(
    `I'd like to share this article from Kingdom Advisors with you. \n\n${articleTitle}\n\n${excerptText}\n\n${link}`
  );

  const email = `mailto:?subject=${subject}&body=${body}`;

  const navigation = {
    social: [
      {
        name: 'Facebook',
        type: 'button',
        href: facebook,
        icon: (props) => (
          <FaFacebookF color="black" style={{ fontSize: 14 }} />
        ),
      },
      {
        name: 'X',
        type: 'button',
        href: twitter,
        icon: (props) => (
          <BsTwitterX color="black" style={{ fontSize: 14 }} />
        ),
      },
      {
        name: 'Linked In',
        type: 'button',
        href: linkedIn,
        icon: (props) => (
          <FaLinkedinIn color="black" style={{ fontSize: 14 }} />
        ),
      },
      {
        name: 'Mail',
        type: 'link',
        href: email,
        icon: (props) => (
          <MdOutlineMailOutline color="black" style={{ fontSize: 14 }} />
        ),
      },
      {
        name: 'Copy',
        type: 'copy',
        href: link,
        icon: (props) => (
          <MdOutlineLink color="black" style={{ fontSize: 18 }} />
        ),
      },
    ],
  }

  return (
    <>
      <div className=" flex flex-col justify-center w-full items-center" style={{ paddingTop: 15, paddingBottom: 15, }}>
        <div className='flex flex-row justify-start items-center' style={{ marginLeft: 15, }}>
          <Typography style={{ color: "black", fontSize: 14, marginRight: 10, }}>SHARE: </Typography>
          {navigation.social.map((item, index) => (
            item.type === 'button' ?

              <div
                key={index}
                onClick={() => { window.open(item.href, 'newwindow', 'noopener,noreferrer,width=400,height=400') }}>
                <div
                  style={{
                    cursor: "pointer",
                    marginRight: 10, height: 30, width: 30, borderRadius: 100, backgroundColor: "transparent",
                    border: '1px solid black',
                    borderWidth: 1, borderColor: "black", display: "flex", alignItems: "center", justifyContent: "center"
                  }}
                  className="active:opacity-50 text-white hover:text-gray-500">
                  <item.icon />
                </div>
              </div>
              : item.type === 'copy' ?
              <div
                key={index}
                onClick={() => {
                  navigator.clipboard.writeText(item.href).then(() => {
                    ShowNotification.success("Article copied to clipboard");
                  });
                }}
              >
                <div
                  style={{
                    cursor: "pointer",
                    marginRight: 10, height: 30, width: 30, borderRadius: 100, backgroundColor: "transparent",
                    border: '1px solid black',
                    borderWidth: 1, borderColor: "black", display: "flex", alignItems: "center", justifyContent: "center"
                  }}
                  className="active:opacity-50 text-white hover:text-gray-500">
                  <item.icon />
                </div>
              </div>
              :
              <a
                key={index}
                onClick={(e) => {
                  // Prevent the browser from briefly navigating to a new page/tab.
                  e.preventDefault();
                  // Trigger the default mail client directly.
                  window.location.href = item.href;
                }}
                style={{
                  cursor: "pointer",
                  marginRight: 10, height: 30, width: 30, borderRadius: 100, backgroundColor: "transparent",
                  border: '1px solid black',
                  borderWidth: 1, borderColor: "black", display: "flex", alignItems: "center", justifyContent: "center"
                }}
                href={item.href}
                className="active:opacity-50 text-white hover:text-gray-500">
                <item.icon />
              </a>


          ))}
        </div>

      </div>
    </>
  )
}

